import { render, staticRenderFns } from "./followed.vue?vue&type=template&id=131c171e&scoped=true&"
import script from "./followed.vue?vue&type=script&lang=js&"
export * from "./followed.vue?vue&type=script&lang=js&"
import style0 from "./followed.vue?vue&type=style&index=0&id=131c171e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131c171e",
  null
  
)

export default component.exports